module.exports = __webpack_public_path__ + "static/media/booster-chrome.6195a433.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/UnsupportedBrowser/booster-chrome.png
// module id = 124
// module chunks = 1